import ListItem from "@mui/material/ListItem";
import { useState } from "react";
import { DataViewer } from "@/features/data-viewer/data-viewer";
import { DownloadCsvButton } from "@/features/data-viewer/export/download-csv-button";
import { PanelLayoutToggle } from "@/features/data-viewer/spec/panel-layout-toggle";
import {
    type DataViewerSpecOptions,
    type PanelLayout,
    useZoneDataViewerSpec,
} from "@/features/data-viewer/spec/use-data-viewer-spec";
import { StreamPicker } from "@/features/data-viewer/stream-picker/stream-picker";
import { CLOCK_CADENCE } from "@/providers/wall-clock";

const ZONE_SPEC_OPTIONS: DataViewerSpecOptions = { irrigationBand: true };

/** Its own component so the streams request only runs when the flag lets the viewer render. */
export function ZoneDataViewerSection({ zoneId }: { zoneId: string }) {
    const [panelLayout, setPanelLayout] = useState<PanelLayout>("single");
    const [addedIds, setAddedIds] = useState<number[]>([]);

    const {
        spec: zoneSpec,
        isLoading,
        isError,
        isEmpty,
        plottedStreams,
        isPlottable,
    } = useZoneDataViewerSpec(zoneId, panelLayout, ZONE_SPEC_OPTIONS, addedIds);

    return (
        <ListItem className={"FullsizeZoneOverviewListItem--InfoCard"}>
            <div className={"w-full flex flex-col"}>
                <DataViewer
                    controls={
                        <>
                            <StreamPicker
                                addedIds={addedIds}
                                isPlottable={isPlottable}
                                onAdd={(id) => setAddedIds((ids) => [...ids, id])}
                                onRemove={(id) => setAddedIds((ids) => ids.filter((other) => other !== id))}
                                plottedStreams={plottedStreams}
                                zoneId={zoneId}
                            />
                            <PanelLayoutToggle layout={panelLayout} onChange={setPanelLayout} />
                            <DownloadCsvButton />
                        </>
                    }
                    initialSpec={zoneSpec}
                    isLoading={isLoading}
                    isError={isError}
                    isEmpty={isEmpty}
                    autoRefreshCadence={CLOCK_CADENCE.MINUTES_5}
                    resizable={false}
                />
            </div>
        </ListItem>
    );
}
